import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { IncidentSharedModule } from "@dtm-frontend/search-and-help-shared-lib/incident";
import { SharedUiModule } from "@dtm-frontend/shared/ui";
import { getTranslocoInlineLoader, LanguageCode, SharedI18nModule } from "@dtm-frontend/shared/ui/i18n";
import { TRANSLOCO_SCOPE } from "@ngneat/transloco";
import { LetModule, PushModule } from "@ngrx/component";
import { NgxsModule } from "@ngxs/store";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { DashboardApiService } from "./services/dashboard-api.service";
import { DashboardState } from "./state/dashboard.state";

@NgModule({
    imports: [
        CommonModule,
        IncidentSharedModule,
        LetModule,
        MatTabsModule,
        NgxsModule.forFeature([DashboardState]),
        PushModule,
        SharedI18nModule,
        SharedUiModule,
    ],
    declarations: [DashboardComponent],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            multi: true,
            useValue: {
                scope: "sahMobileLibDashboard",
                loader: getTranslocoInlineLoader((language: LanguageCode) => import(`./assets/i18n/${language}.json`)),
            },
        },
        DashboardApiService,
    ],
})
export class DashboardModule {
    public static forTest(): ModuleWithProviders<DashboardModule> {
        return {
            ngModule: DashboardModule,
            providers: [
                {
                    provide: DashboardApiService,
                    useValue: null,
                },
            ],
        };
    }
}
